export default __webpack_public_path__ + "static/media/blog-39-7.6f3c872a.png";